import { render, staticRenderFns } from "./ManageRateId.vue?vue&type=template&id=055fea77"
import script from "./ManageRateId.vue?vue&type=script&lang=js"
export * from "./ManageRateId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports